import { notificationMockService } from '../notification-mock/notification-mock-service';
import { NotificationApiService } from './notification-api-service';
import { NotificationService } from './notification-service.interface';

/**
 * Toggle to false when the backend notification endpoints are deployed.
 * TODO: Move to environment-based config when notification feature is stable.
 */
const USE_MOCK_NOTIFICATIONS = true;

export const notificationService: NotificationService =
  USE_MOCK_NOTIFICATIONS ? notificationMockService : new NotificationApiService();
